import { render, staticRenderFns } from "./EditableColorsIcons.vue?vue&type=template&id=455cd420&"
import script from "./EditableColorsIcons.vue?vue&type=script&lang=js&"
export * from "./EditableColorsIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports